import { findPrinterInterface } from "./findPrinterInterface";
import { isElectron, getIpcRenderer } from "./electronBridge";

let cachedPrinterDevice = null;

// Bouton manuel pour autoriser l'imprimante
export const connectPrinter = async () => {
  try {
    // Sous Electron, on passe par le process principal (module USB natif) :
    // le WebUSB du renderer refuse de claim les interfaces de cette imprimante
    // (restriction "protected interface class" / limitation Windows), alors
    // que l'accès natif via libusb/WinUSB fonctionne de façon fiable.
    if (isElectron()) {
      await getIpcRenderer().invoke("printer:connect");
      console.log("✅ Imprimante connectée (Electron)");
      return;
    }

    if (!("usb" in navigator)) throw new Error("WebUSB non supporté");

    let device = cachedPrinterDevice;

    if (device) {
      const devices = await navigator.usb.getDevices();
      if (!devices.find((d) => d.vendorId === device.vendorId && d.productId === device.productId)) {
        device = null;
        cachedPrinterDevice = null;
      }
    }

    if (!device) {
      device = await navigator.usb.requestDevice({ filters: [] });
      cachedPrinterDevice = device;
    }

    if (!device.opened) await device.open();
    if (!device.configuration) await device.selectConfiguration(1);

    const printerInterface = await findPrinterInterface(device);
    if (!printerInterface) {
      const lines = device.configuration.interfaces.flatMap((iface) =>
        iface.alternates.map(
          (alt) =>
            `iface=${iface.interfaceNumber} alt=${alt.alternateSetting} class=0x${alt.interfaceClass
              .toString(16)
              .padStart(2, "0")} sub=0x${alt.interfaceSubclass.toString(16).padStart(2, "0")} ` +
            `endpoints=[${alt.endpoints.map((e) => `${e.direction}/${e.type}`).join(",")}]`
        )
      );
      console.log("🔍 Interfaces vues par ce navigateur :\n" + lines.join("\n"));
      throw new Error("Aucune interface imprimante claimable trouvée sur ce périphérique");
    }

    console.log("✅ Imprimante connectée :", device);
  } catch (err) {
    console.error("Échec de connexion imprimante :", err);
  }
};